import api from "./api";
import { WAAssignPayload, WASendPayload } from "../types/whatsapp";

// --- WhatsApp Inbox ---
export const listConversations = (params: {
  filter?: "mine" | "unassigned" | "all";
  q?: string;
  page?: number;
}) => api.get("wa/conversations", { params });

export const getMessages = (id: string, page = 1) =>
  api.get(`wa/conversations/${id}/messages`, { params: { page } });

export const markRead = (id: string) =>
  api.post(`wa/conversations/${id}/read`);

export const sendMessage = (id: string, payload: WASendPayload) =>
  api.post(`wa/conversations/${id}/messages`, payload);

export const assignConversation = (id: string, payload: WAAssignPayload) =>
  api.post(`wa/conversations/${id}/assign`, payload);

export const getUnreadCount = () => api.get("wa/unread-count");

// --- File Upload Helper for Outbound WhatsApp Media ---
export const uploadImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("path", "wa-media");
  const response = await api.post("upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data?.data?.url as string;
};
